<div class="vt-MainWidth">
	<!--Main Grid-->
	<div class="vt-MainGrid">
		<label>Action Trigger Type:</label>
		<label>{{ TriggerType }}</label>

		<label>Occurs When:</label>
		<label>{{ OccursWhen }}</label>

		<label>Results In:</label>
		<label>{{ ResultsIn }}</label>

		<label>Reset Conditions:</label>
		<label>{{ ResetCond }}</label>

		<label>Created By:</label>
		<label>{{ CreatedBy }}</label>

		<label>Created On:</label>
		<label>{{ CreatedOn }}</label>
	</div>

	<!--Button(s)-->
	<div class="vt-Buttons">
		<button class="btn btn-primary" (click)="onClose()">Close</button>
	</div>
</div>
